import { createStyles } from "@mantine/core";
import moment from "moment";


const useStyles = createStyles(() => ({
  card: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    padding: "10px 8px",
    border: "1px solid transparent",
    borderRadius: "6px",
    gap: "2px",
    cursor: "default",
    userSelect: "none",
  },

  dayName: {
    margin: 0,
    fontSize: "11px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#667085",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    lineHeight: 1.2,
  },

  dateCircle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    marginTop: "2px",
  },

  dateNumber: {
    margin: 0,
    fontSize: "15px",
    fontWeight: 700,
    fontFamily: "Inter",
    color: "#101828",
    lineHeight: 1,
  },

  activeCard: {
    backgroundColor: "#FAE7BE",
    borderColor: "#FFBA45",
  },

  activeDayName: {
    color: "#92400E",
  },

  activeDateNumber: {
    color: "#92400E",
  },
}));

const DateCard = ({ date }) => {
  const { classes, cx } = useStyles();
  const _dateFormat = "YYYY-MM-DD";
  const isToday =
    moment(date).format(_dateFormat) === moment().format(_dateFormat);

  return (
    <div className={cx(classes.card, { [classes.activeCard]: isToday })}>
      <p className={cx(classes.dayName, { [classes.activeDayName]: isToday })}>
        {moment(date).format("ddd")}
      </p>
      <div className={classes.dateCircle}>
        <p
          className={cx(classes.dateNumber, {
            [classes.activeDateNumber]: isToday,
          })}
        >
          {moment(date).format("DD")}
        </p>
      </div>
    </div>
  );
};

export default DateCard;
